import React from 'react';
import './index.scss';
import { Bubble } from 'tea-component';
const TabComponents = (props: any) => {
  let { data } = props;
  return (
    <div className="dbi-tab-components">
      {data ? (
        <Bubble dark placement="top" content={data.context ? data.context : ''}>
          <div
            className="dbi-tab-components-text"
            style={{
              color: data?.color,
              backgroundColor:
                data?.bgColor || data?.color
                  ? hexToRgb(data?.bgColor || data?.color, '.1')
                  : '',
            }}
          >
            {data.text}
          </div>
        </Bubble>
      ) : (
        ''
      )}
    </div>
  );
};

export default TabComponents;
function hexToRgb(hex: any, opacity?: any) {
  // 将十六进制颜色值转换为 RGB 值
  const r = parseInt(hex.substring(1, 3), 16);
  const g = parseInt(hex.substring(3, 5), 16);
  const b = parseInt(hex.substring(5, 7), 16);
  return `rgba(${r}, ${g}, ${b},${opacity})`;
}
